/** @jsxImportSource @emotion/react */
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../../core/redux/IAppState";
import { MODAL_SIZE } from "../../layout/modal/modalSize";
import ModalTitleHeader from "../../layout/modal/ModalTitleHeader";
import ModalView, { ModalContent } from "../../layout/modal/ModalView";
import { doNothing } from "../../language/module";
import { COLUMN_SPACING, ROW_SPACING } from "../../forms/styles";
import { Column, Row } from "../../layout/flexbox";
import { getResource } from "../../language/resources/getResource";
import visitorIcon from "../../assets/icons/visitor.svg";
import * as Buttons from "../../forms/elements/buttons";
import { css } from "@emotion/react";
import WeeklyVisitorReports from "./WeeklyVisitorReports";
import { clearWeeklyVisitorReportsAction } from "./clearWeeklyVisitorReportsAction";

const weeklyVisitorReportsModalCss = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${COLUMN_SPACING};
`;

type Props = {
  onDismiss?: () => void;
};

export const WeeklyVisitorReportsModal = (props: Props) => {
  const dispatch = useDispatch();
  const resources = useSelector((state: IAppState) => state.locale);

  const clearReports = () => dispatch(clearWeeklyVisitorReportsAction())

  const onCloseReport = () => {
    clearReports();
    (props.onDismiss || doNothing)();
  }

  return (
    <ModalView
      onDismiss={onCloseReport}
      size={MODAL_SIZE.DYNAMIC}
      contentCss={weeklyVisitorReportsModalCss}
      disableClickoffDismissable={true}
    >
      <ModalTitleHeader
        resources={resources}
        onDismiss={onCloseReport}
        heading={getResource(resources, "REPORTS_WEEKLY_VISTOR_DATA")}
        icon={visitorIcon}
      />
      <ModalContent>
        <Column rootCss={COLUMN_SPACING}>
          <WeeklyVisitorReports />
          <Row
            justifyContent="flex-end"
            rootCss={css`
              margin-top: auto;
              margin-right: 50px;
              ${ROW_SPACING}
            `}
          >
            <Buttons.BigNeutral
              type="submit"
              onClick={onCloseReport}
              title={getResource(
                resources,
                "REPORTS_WEEKLY_VISITOR_DATA_CLOSE_TITLE"
              )}
            >
              {getResource(resources, "REPORTS_CLOSE")}
            </Buttons.BigNeutral>
          </Row>
        </Column>
      </ModalContent>
    </ModalView>
  );
};
